// extracted by mini-css-extract-plugin
export default {"backgroundImage":"MobileComponent_backgroundImage__PZPFD"};